import type { CarouselData } from './model';

/** What the post screen and its render iframe say to each other (`postMessage`). */
export type ToRenderer = { type: 'kit-render'; data: CarouselData };
export type FromRenderer =
  | { type: 'kit-ready' }
  | { type: 'kit-progress'; n: number; progress: number }
  | { type: 'kit-file'; n: number; blob: Blob }
  | { type: 'kit-failed'; n: number }
  | { type: 'kit-unsupported' };

export const RENDER_PATH = '/post/render';

/** The render iframe is not a page anyone visits: no bar, and no pageview in any analytics. */
export const isRenderRoom = (pathname: string | null) => pathname === RENDER_PATH;
